import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import BlackFridayPopup from "./components/BlackFridayPopup";

// Lazy loading pages
const Home = React.lazy(() => import("./pages/Home"));
const MetaAds = React.lazy(() => import("./pages/MetaAds"));
const GoogleAds = React.lazy(() => import("./pages/GoogleAds"));
const SocialMedia = React.lazy(() => import("./pages/SocialMedia"));
const SocialMediaVitrine = React.lazy(() => import("./pages/SocialMediaVitrine"));
const EnsaiosFoodPorn = React.lazy(() => import("./pages/EnsaiosFoodPorn"));
const EngenhariaCardapio = React.lazy(() => import("./pages/EngenhariaCardapio"));
const Edicao = React.lazy(() => import("./pages/Edicao"));
const CopyRoteiros = React.lazy(() => import("./pages/CopyRoteiros"));
const Outros = React.lazy(() => import("./pages/Outros"));
const Contato = React.lazy(() => import("./pages/Contato"));
const EscolaEmpreendedor = React.lazy(() => import("./pages/EscolaEmpreendedor"));
const AssessoriaComercial = React.lazy(() => import("./pages/AssessoriaComercial"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#D4AF37]"></div>
  </div>
);

function App() {
  // Determine basename: use '/comprecliente' for localhost, otherwise '/' for production
  const basename = window.location.hostname === 'localhost' ? '/comprecliente' : '/';

  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <Navbar />
        <main className="pt-20">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/meta-ads" element={<MetaAds />} />
              <Route path="/google-ads" element={<GoogleAds />} />
              <Route path="/social-media" element={<SocialMedia />} />
              <Route path="/social-media-vitrine" element={<SocialMediaVitrine />} />
              <Route path="/ensaios-foodporn" element={<EnsaiosFoodPorn />} />
              <Route path="/engenharia-cardapio" element={<EngenhariaCardapio />} />
              <Route path="/edicao" element={<Edicao />} />
              <Route path="/copy-roteiros" element={<CopyRoteiros />} />
              <Route path="/outros" element={<Outros />} />
              <Route path="/contato" element={<Contato />} />
              <Route path="/escola-empreendedor" element={<EscolaEmpreendedor />} />
              <Route path="/assessoria-comercial" element={<AssessoriaComercial />} />

              {/* Rotas dos novos serviços - redirecionar para páginas similares temporariamente */}
              <Route path="/tiktok-taboola" element={<GoogleAds />} />
              <Route path="/ensaios-casual" element={<EnsaiosFoodPorn />} />
              <Route path="/fotos-cardapio" element={<EnsaiosFoodPorn />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <BlackFridayPopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
